var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialSymbols(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.425L5.75 21.675C5.55 21.875 5.31667 21.971 5.05 21.963C4.78333 21.955 4.55 21.8507 4.35 21.65C4.16667 21.45 4.071 21.2167 4.063 20.95C4.055 20.6833 4.15067 20.45 4.35 20.25L6.6 18H5.35C5.06667 18 4.82933 17.9043 4.638 17.713C4.44667 17.5217 4.35067 17.284 4.35 17C4.34933 16.716 4.44533 16.4787 4.638 16.288C4.83067 16.0973 5.068 16.0013 5.35 16H9C9.28333 16 9.521 16.096 9.713 16.288C9.905 16.48 10.0007 16.7173 10 17V20.65C10 20.9333 9.904 21.171 9.712 21.363C9.52 21.555 9.28267 21.6507 9 21.65C8.71733 21.6493 8.48 21.5537 8.288 21.363C8.096 21.1723 8 20.9347 8 20.65V19.425ZM13 22C12.7167 22 12.4793 21.904 12.288 21.712C12.0967 21.52 12.0007 21.2827 12 21V17C12 16.1667 11.7083 15.4583 11.125 14.875C10.5417 14.2917 9.83333 14 9 14H5C4.71667 14 4.47933 13.904 4.288 13.712C4.09667 13.52 4.00067 13.2827 4 13V4C4 3.45 4.196 2.97933 4.588 2.588C4.98 2.19667 5.45067 2.00067 6 2H14L20 8V20C20 20.55 19.8043 21.021 19.413 21.413C19.0217 21.805 18.5507 22.0007 18 22H13ZM13 9H18L13 4V9Z",
    fill: "#253837"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbols);
export default __webpack_public_path__ + "static/media/material-symbols.3c152e5f68228d0e71d8f02d88c0f276.svg";
export { ForwardRef as ReactComponent };